import apiService from './api';
import { Employee, CreateEmployeeData, UpdateEmployeeData } from '../types/employeeTypes';

class EmployeeService {
  async getEmployees(): Promise<Employee[]> {
    const response = await apiService.get<Employee[]>('/employees');
    return response.data
  }

  async getEmployee(id: string): Promise<Employee> {
    const response = await apiService.get<Employee>(`/employees/${id}`);
    return response.data;
  }

  async createEmployee(data: CreateEmployeeData): Promise<Employee> {
    const response = await apiService.post<Employee>('/employees', data);
    return response.data;
  }

  async updateEmployee(data: UpdateEmployeeData): Promise<Employee> {
    const response = await apiService.put<Employee>(`/employees/${data.id}`, data);
    return response.data;
  }

  async deleteEmployee(id: string): Promise<void> {
    await apiService.delete(`/employees/${id}`);
  }

  async toggleEmployeeStatus(id: string): Promise<Employee> {
    const response = await apiService.patch<Employee>(`/employees/${id}/toggle-status`);
    return response.data;
  }
}

export const employeeService = new EmployeeService();
export default employeeService;